import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
// import { v4 as uuidv4 } from "uuid";
import autoBind from "react-autobind";

import FiltroData from "./FiltroData";

export class ListaNoticias extends Component {
  constructor() {
    super();
    this.state = {
      noticias: [],
      filtroAno: "",
      filtroMes: "",
    };
    autoBind(this);
  }

  abortController = new AbortController();

  componentDidMount() {
    axios
      .get(`https://ipbnews.ipb.pt/submissao/index.php?r=submissao/json`)
      .then((res) => this.setState({ noticias: res.data }))
      .catch((err) => {
        console.log("error", err.name);
        if (err.name === "AbortError") return;
        throw err;
      });
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  handleChange(ev) {
    if (ev.target.name === "Ano") {
      this.setState({ filtroAno: ev.target.value });
    } else {
      let liElements = document
        .querySelector(".mesesList")
        .getElementsByTagName("li");
      if (ev.target.getAttribute("value") !== "0") {
        for (var i = 0; i < liElements.length; i++) {
          liElements[i].classList.value = "";
        }
      }
      if (ev.target.name === "Mes") {
        this.setState({ filtroMes: ev.target.value });
        liElements[ev.target.value ? ev.target.value : 0].classList.value =
          "selected";
      } else {
        if (ev.target.getAttribute("value") !== "0") {
          this.setState({ filtroMes: ev.target.getAttribute("value") });
          liElements[ev.target.getAttribute("id")].classList.value = "selected";
        }
      }
    }
  }

  render() {
    const { noticias, filtroAno, filtroMes } = this.state;

    let noticiasFiltro = noticias.filter((noticia) => {
      let ano = new Date(noticia.data).getFullYear().toString();
      let mes = new Date(noticia.data).toLocaleDateString("pt-PT", {
        month: "numeric",
      });
      if (filtroMes) {
        return mes === filtroMes && ano.includes(filtroAno);
      } else {
        return true && ano.includes(filtroAno);
      }
    });

    return (
      <div className="notContainer">
        <FiltroData
          noticias={noticias}
          filtroAno={filtroAno}
          filtroMes={filtroMes}
          handleChange={this.handleChange}
        />
        <div className="noticiasContainer">
          {noticiasFiltro.map((noticia) => (
             <div key={noticia.press_noticia_id}>
              {<img src={`https://ipbnews.ipb.pt/submissao/uploads/${noticia.foto}`} alt="NoticiaImg" />}
              <div className="detalhes">
                <span>
                  {new Date(noticia.data).toLocaleDateString("pt-PT", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </span>
                <i className="fas fa-long-arrow-alt-right"></i>
                <Link to={`/noticias/${noticia.press_noticia_id}`}>
                  {noticia.titulo}
                </Link>
              </div>
            </div>
          ))}
        </div>
       
      </div>
    );
  }
}

export default ListaNoticias;
